import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { green, grey } from '@material-ui/core/colors';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import { EditorState, convertToRaw, ContentState, AtomicBlockUtils } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import axios from '../../services/axios';
import jwt from 'jsonwebtoken';
import { useCookies } from 'react-cookie'

import Loader from '../Loader';

import Select from 'react-select';
import { EmailEditorContainer, UsersEmailTest } from '../Newsletter/styled';
import { BiTrash } from 'react-icons/bi';
import { CiImageOn } from 'react-icons/ci';

const GreenCheckbox = withStyles({
    root: {
        color: grey[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props: CheckboxProps) => <Checkbox color="primary" {...props} />);

const NewAnnouncement: React.FC = () => {
    const [imageUrlFile, setImageUrlFile] = useState<File | null>(null);
    const [cookies, ,] = useCookies(["token"]);
    const token: any = cookies.token
    const [loaded, setLoaded] = useState<boolean>(true);
    const [checked, setChecked] = useState<boolean>(false);
    const [locationChecked, setLocationChecked] = useState<boolean>(false);
    const [emailChecked, setEmailChecked] = useState<boolean>(false);
    const [smsChecked, setSmsChecked] = useState<boolean>(false);
    const [optEveryone, setOptEveryone] = useState<boolean>(false);
    const [group, setGroup] = useState<any>([])
    const [location, setLocation] = useState<any>([])
    const [imageFile, setImageFile] = useState({
        selectedFile: "",
        type: ""
    })
    const [imageName, setImageName] = useState("")
    const [description, setDescription] = useState<any>(EditorState.createEmpty())
    const [subject, setSubject] = useState<string>("")
    const [confirmation, setConfirmation] = useState<boolean>(false)
    const [modalLoading, setModalLoading] = useState<boolean>(false)
    const [myPreview, setMyPreview] = useState<boolean>(false)
    const [locationsInfo, setLocationsInfo] = useState([]);
    const [rolesInfo, setRolesInfo] = useState([]);
    const [handleFileDoc, setHandleFileDoc] = useState({
        selectedFile: '',
        type: ''
    });
    const [notifyMobile, setNotifyMobile] = useState<boolean>(false);
    const [notifyDesktop, setNotifyDesktop] = useState<boolean>(false);
    const [strings, setStrings] = useState<string[]>([]);
    const [inputValue, setInputValue] = useState('');
    const [editorType, setEditorType] = useState<string>('default'); // New state for editor type
    const history = useHistory();
    useEffect(() => {
        handlePermissions()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const getTextFromEditorState = () => {
        const contentState = description.getCurrentContent();
        const rawText = convertToRaw(contentState);
        const text = rawText.blocks.map(block => (!block.text.trim() && '\n') || block.text).join('\n');
        return text
    };

    const fetchLocations = async () => {
        const data = await axios.get('/api/v1/contacts/locations');
        setLocationsInfo(data.data);
    }

    const fetchGroups = async () => {
        const data = await axios.get('/api/v1/contacts/roles');
        setRolesInfo(data.data);
    }
    const addString = () => {
        if (inputValue.trim() !== '') {
            setStrings([...strings, inputValue]);
            setInputValue('');
        }
    };
    const insertImage = (imgUrl: string) => {
        const contentState = description.getCurrentContent();

        // Cria uma entidade para a imagem
        const contentStateWithEntity = contentState.createEntity(
            'IMAGE', // Tipo da entidade
            'IMMUTABLE', // Tipo de mutabilidade
            { src: imgUrl, class: 'img-field' } // Dados associados
        );

        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

        // Usa o AtomicBlockUtils para inserir a entidade no editor
        const newEditorState = AtomicBlockUtils.insertAtomicBlock(
            description,
            entityKey,
            ' '
        );

        // Atualiza o estado do editor
        setDescription(
            EditorState.forceSelection(newEditorState, newEditorState.getSelection())
        );

    };
    const createImageUrl = async (file: any) => {
        const dataFile = new FormData();
        console.log(imageUrlFile);
        if (file) {
            dataFile.append('file', file);
        }
        await axios
            .post('/api/v1/latest-news/uploadFile', dataFile, { timeout: 0 })
            .then((res) => {
                console.log(res.data);
                insertImage(res.data.url);
            });
    };
    const handleFileImageUrl = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            createImageUrl(event.target.files[0]);
        }
    };
    const removeString = (index: number) => {
        setStrings(strings.filter((_, i) => i !== index));
    };
    const exportHtmlAsync = () => {
        return new Promise((resolve, reject) => {
            // @ts-ignore
            window.unlayer.exportHtml((data) => {
                const { html } = data;
                if (html) {
                    resolve(html);
                } else {
                    reject("Failed to export HTML");
                }
            });
        });
    };
    const handleTestEmail = async () => {
        let HtmlText = "";
        if (editorType !== 'default') {

            try {
                HtmlText = await exportHtmlAsync() as string;
                console.log("HTML :", HtmlText);
            } catch (error) {
                alert("Error HTML: " + error);
                return;
            }
        }
        const htmlDescription = draftToHtml(
            convertToRaw(description.getCurrentContent())
        );
        console.log(strings)


        axios.post('/api/v1/announcements/email-test', {
            subject: subject,
            info: editorType === 'default' ? htmlDescription : HtmlText,
            doc: handleFileDoc,
            email: strings,
            image: imageFile,
            editor_type: editorType,
        }).then(() => {
            alert("Email sent")

        })

    }
    const handlePastedText = (
        text: string,
        html?: string | undefined,
        editorState?: EditorState
    ): boolean => {
        if (text) {
            // Insere apenas o texto puro no estado do editor
            const contentState = editorState?.getCurrentContent() || EditorState.createEmpty().getCurrentContent();
            const newContentState = ContentState.createFromText(
                contentState.getPlainText() + text // Adiciona o texto colado ao conteúdo existente
            );

            setDescription(
                EditorState.push(editorState || EditorState.createEmpty(), newContentState, 'insert-characters')
            );
            return true; // Indica que o evento foi tratado
        }
        return false; // Permite o comportamento padrão se nenhuma ação for realizada
    };


    useEffect(() => {
        // Adiciona o script Unlayer dinamicamente
        const script = document.createElement('script');
        script.src = 'https://editor.unlayer.com/embed.js';
        script.async = true;
        script.onload = () => {
            // Inicializa o editor
            // @ts-ignore
            window.unlayer.init({
                id: 'editor-container',
                projectId: 264208, // Substitua pelo seu projectId se tiver um
                displayMode: 'email',
            });

        };
        document.body.appendChild(script);

        // Remove o script ao desmontar o componente
        return () => {
            document.body.removeChild(script);
        };
    }, [editorType]);

    const publishAnnouncement = async () => {
        const id = localStorage.getItem('owner_id');
        let users = [];

        const formattedLocation = [];
        if (group) {
            for (let index = 0; index < group.length; index++) {
                formattedLocation.push(group[index].value)
            }
        }
        const formattedRoles = [];
        if (location) {
            for (let index = 0; index < location.length; index++) {
                formattedRoles.push(location[index].value)
            }
        }

        if (optEveryone) {
            const req = await axios.get('/api/v1/contacts');
            users = req.data;
        }

        if (checked && !locationChecked) {
            const req = await axios.post('/api/v1/contacts/byLocation', { location: formattedLocation });
            users = req.data;
        }

        if (locationChecked && !checked) {
            const req = await axios.post('/api/v1/contacts/byRole', { role: formattedRoles });
            users = req.data;
        }

        if (checked && locationChecked) {
            const locationsReq = await axios.post('/api/v1/contacts/byLocation', { location: formattedLocation });
            let users2 = locationsReq.data
            let filteredUsers = []
            for (let index = 0; index < users2.length; index++) {
                if (location) {
                    for (let counter = 0; counter < location.length; counter++) {
                        if (users2[index].role === location[counter].value) {
                            filteredUsers.push(users2[index])
                        }
                    }
                }
            }
            if (filteredUsers.length > 0) users = filteredUsers
        }

        let HtmlText = "";
        if (editorType !== 'default') {

            try {
                HtmlText = await exportHtmlAsync() as string;
                console.log("HTML :", HtmlText);
            } catch (error) {
                alert("Error HTML: " + error);
                return;
            }
        }
        // const blocks = convertToRaw(description.getCurrentContent()).blocks;
        // const infoValue = blocks.map(block => (!block.text.trim() && '\n') || block.text).join('\n');
        const htmlDescription = draftToHtml(convertToRaw(description.getCurrentContent()))
        let created = new Date()
        const data = {
            groups_ids: [],
            owner_id: id,
            locations_ids: [],
            image: imageFile,
            subject: subject,
            info: editorType === 'default' ? htmlDescription : HtmlText,
            text: editorType === 'default' ? getTextFromEditorState() : HtmlText,
            editor_type: editorType,
            users: users,
            createdAt: created.toString().split("").splice(4, 17).join(""),
            emailChecked,
            smsChecked,
            doc: handleFileDoc,
            notify_mobile: notifyMobile,
            notify_desktop: notifyDesktop
        }

        if (subject !== undefined
            && description !== undefined) {
            try {
                if (users.length > 0) {
                    setModalLoading(true)
                    await axios.post(`/api/v1/announcements/ap`, data)
                    setConfirmation(false)
                    alert("Announcement created")
                    history.push('/announcements')
                    window.location.reload()
                } else {
                    alert("0 contacts found.")
                }
            } catch (error) {
                setModalLoading(false)
                alert(error)
            }
        }

    }

    async function createAnnouncement() {
        const id = localStorage.getItem('id');

        if (optEveryone === false && checked === false && locationChecked === false) {
            setConfirmation(false)
            return alert("Invalid announcement type")
        }

        if (subject === "") {
            setConfirmation(false)
            return alert("Invalid subject")
        }

        if (description._immutable._map.length <= 7) {
            setConfirmation(false)
            return alert("Invalid description")
        }

        const htmlDescription = draftToHtml(convertToRaw(description.getCurrentContent()))
        let created = new Date()
        const data = {
            groups_ids: group,
            owner_id: id,
            locations_ids: location,
            image: imageFile,
            subject: subject,
            info: htmlDescription,
            createdAt: created.toString().split("").splice(4, 17).join(""),
            doc: handleFileDoc
        }

        if (subject !== undefined
            && description !== undefined) {
            try {
                setModalLoading(true)
                await axios.post(`/api/v1/announcements`, data)
                setConfirmation(false)
                alert("Announcement created")
                history.push(`/announcements`)
            } catch (error) {
                setModalLoading(false)
                alert(error)
            }
        }
    }
    function docSelect(props: any) {
        if (props[0] === undefined) {
            setHandleFileDoc({
                selectedFile: '',
                type: ''
            });
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(props[0]);

        reader.onload = (e: any) => {
            setHandleFileDoc({
                selectedFile: e?.target?.result,
                type: props[0].type
            });
        };
    }

    function handlePermissions() {
        jwt.verify(token!.toString(), '8Zz5tw0Ionm3XPZZfN0NOml3z9FMfmpgXwovR9fp6ryDIoGRM8EPHAB6iHsc0fb', (err: any, decoded: any) => {
            if (err) {
                alert(err)
            } else {
                if (decoded.roles.announcements.add === false) {
                    alert("Permission denied")
                    window.location.href = `${process.env.REACT_APP_URL}`
                } else {
                    setLoaded(false)
                }
            }
        })
    }

    function handleChange() {
        if (checked === false) {
            setGroup([])
            setChecked(true)
        } else if (checked === true) {
            setChecked(false)
        }
    }

    function handleLocation() {
        if (locationChecked === false) {
            setLocation([])
            setLocationChecked(true)
        } else if (locationChecked === true) {
            setLocationChecked(false)
        }
    }

    function handleEveryone() {
        if (optEveryone === false) {
            setOptEveryone(true)
            setGroup([])
            setLocation([])
        } else if (optEveryone === true) {
            setOptEveryone(false)
        }
    }

    function fileSelect(props: any) {
        if (props[0] === undefined) {
            setImageName("")
            setImageFile({
                selectedFile: "",
                type: "",
            })
            return
        }
        setImageName(props[0].name)
        const reader = new FileReader()
        reader.readAsDataURL(props[0])

        reader.onload = (e: any) => {
            setImageFile({
                selectedFile: e?.target?.result,
                type: props[0].type
            })
        }
    }

    const handleSelectGroup = (event: any) => {
        setGroup(event)
    };

    const handleSelectLocation = (event: any) => {
        setLocation(event)
    };

    window.onclick = function (event: any) {
        if (event.target.className === 'modal') {
            setConfirmation(false)
        }
    }

    const groups = (
        <div className="specific-groups">

            <FormControlLabel
                control={
                    <GreenCheckbox
                        onChange={handleChange}
                        name="checkedG"
                    />}
                label="Specific Location"
                checked={checked ? true : false}
            />

            <Select
                isMulti
                name="colors"
                options={locationsInfo}
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={handleSelectGroup}
            />
        </div>
    )

    const locations = (
        <div className="specific-groups">
            <FormControlLabel
                control={
                    <GreenCheckbox
                        onChange={handleLocation}
                        name="checkedA"
                    />}
                label="Job Title (Group)"
                checked={locationChecked ? true : false}
            />

            <Select
                isMulti
                name="colors"
                options={rolesInfo}
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={handleSelectLocation}
            />

        </div>
    )


    const myModal = (
        <div id="myModal" style={{ display: confirmation ? "block" : "none" }} className="modal">
            <div className="modal-content">
                <div className="modal-header">
                    <span onClick={() => setConfirmation(false)} className="close">&times;</span>
                    <h2>
                        Your announcement is about to be published.
                        When publishing an announcement all selected users will receive an email and will be able
                        to read the announcement on their pages.
                        Would you like to publish it now?
                    </h2>
                </div>
                <div className="modal-confirmation">
                    <form>
                        {(modalLoading ? <Loader />
                            :
                            <>
                                <button type="button" onClick={createAnnouncement} className="deletebtn">Yes</button>
                                <button type="button" onClick={() => setConfirmation(false)} className="cancelbtn">No</button>

                            </>
                        )}
                    </form>
                </div>
            </div>
        </div>)

    const preview = (
        <div style={{ display: myPreview ? "block" : "none", maxWidth: "100%" }}>
            <span onClick={() => setMyPreview(false)} className="close">&times;</span>
            <h1 style={{ margin: 0 }}>{subject}</h1>
            <div
                dangerouslySetInnerHTML={{
                    __html: draftToHtml(convertToRaw(description.getCurrentContent())).replace(/\n/g, '<br/>')
                        .replace(/<p><\/p>/g, '<br/>')
                }}
            ></div>
        </div >)

    return (
        loaded ? <Loader />
            :
            <div className="new-announcement">
                <h1>FEG Announcement</h1>
                <div className="create-announcement">
                    <h4>Target</h4>
                    <FormControlLabel
                        control={
                            <GreenCheckbox
                                name="checkedG"
                                onChange={handleEveryone}
                            />}
                        label="Everyone"
                        disabled={checked || locationChecked ? true : false}
                        className='create-announcement-everyone'
                    />
                    <FormControlLabel
                        control={
                            <GreenCheckbox
                                onChange={handleChange}
                                name="checkedG"
                            />}
                        label="Specific Location"
                        style={{ display: checked ? "none" : "block" }}
                        checked={checked ? true : false}
                        onClick={() => fetchLocations()}
                        disabled={optEveryone ? true : false}
                    />
                    {
                        (checked ? groups : <></>)
                    }
                    <FormControlLabel
                        control={
                            <GreenCheckbox
                                onChange={handleLocation}
                                name="checkedA"
                            />}
                        label="Job Title (Group)"
                        style={{ display: locationChecked ? "none" : "block" }}
                        checked={locationChecked ? true : false}
                        onClick={() => fetchGroups()}
                        disabled={optEveryone ? true : false}
                    />
                    {
                        (locationChecked ? locations : <></>)
                    }

                </div>
                <div className="create-announcement">
                    <h4>Channels</h4>
                    <FormControlLabel
                        control={
                            <GreenCheckbox
                                onChange={() => setEmailChecked(!emailChecked)}
                                name="checkedG"
                            />}
                        label="Email"
                    // style={{ display: checked ? "none" : "block" }}
                    // checked={checked ? true : false}
                    // disabled={optEveryone ? true : false}
                    />
                    {/* {
                        (checked ? groups : <></>)
                    } */}
                    <FormControlLabel
                        control={
                            <GreenCheckbox
                                onChange={() => setSmsChecked(!smsChecked)}
                                name="checkedA"
                            />}
                        label="SMS"
                    // style={{ display: locationChecked ? "none" : "block" }}
                    // checked={locationChecked ? true : false}
                    // disabled={optEveryone ? true : false}
                    />
                    {/* {
                        (locationChecked ? locations : <></>)
                    } */}

                    <FormControlLabel
                        control={<Checkbox color='primary' />}
                        label='Push Notification'
                        color='primary'
                        value={notifyMobile}
                        onChange={() => setNotifyMobile(!notifyMobile)}
                    />
                    <FormControlLabel
                        control={<Checkbox color='primary' />}
                        label='Website Notification'
                        color='primary'
                        value={notifyDesktop}
                        onChange={() => setNotifyDesktop(!notifyDesktop)}
                    />
                </div>
                <div className="utils">
                    <h4>Subject</h4>
                    <input
                        type="text"
                        name="nameInput"
                        value={subject}
                        maxLength={250}
                        onChange={e => setSubject(e.target.value)}
                    />
                    <h4>Attachment</h4>
                    <input
                        type='file'
                        maxLength={250}
                        style={{ display: 'flex' }}
                        onChange={(e) => docSelect(e.target.files)}
                    />
                    <h4>Picture</h4>
                    <div className="imageInput">
                        <label style={{ display: (imageName.length <= 0 || imageName === undefined) ? "" : "none" }} htmlFor='inputFileImg'>+</label>
                        <label style={{ display: (imageName.length >= 1 && imageName !== undefined) ? "" : "none", padding: "7px 10px" }} htmlFor='inputFileImg'>{imageName}</label>
                        <input
                            id="inputFileImg"
                            className="typefile"
                            type="file"
                            accept=".jpg,.png"
                            onChange={event => fileSelect(event.target.files)}
                        />
                        <p>images less than 4 mb only</p>
                    </div>
                    <h4>Editor Type</h4>
                    <select
                        value={editorType}
                        onChange={(e) => setEditorType(e.target.value)}
                        style={{
                            padding: '10px',
                            marginBottom: '20px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                        }}
                    >
                        <option value="default">Default Editor</option>
                        <option value="email">Complex Editor</option>
                    </select>
                    {editorType === 'default' ? (
                        <>
                            <h4>Announcement</h4>
                            <Editor
                                editorState={description}
                                wrapperClassName="demo-wrapper"
                                handlePastedText={handlePastedText}
                                editorClassName="demo-editor"
                                stripPastedStyles={true}
                                toolbarCustomButtons={[
                                    <>
                                        <label
                                            htmlFor='image-upload-url'
                                            style={{
                                                padding: 0,
                                                borderRadius: 4,
                                                margin: 3,
                                                cursor: 'pointer'
                                            }}
                                        >
                                            {<CiImageOn size={20} />}
                                        </label>

                                        <input
                                            id='image-upload-url'
                                            type='file'
                                            onChange={(file) => {
                                                handleFileImageUrl(file);
                                            }}
                                        />
                                    </>
                                ]}
                                onEditorStateChange={e => { setDescription(e) }}
                            />
                        </>
                    ) : (
                        <EmailEditorContainer>
                            <div id="editor-container" style={{ width: '100%' }}></div>
                        </EmailEditorContainer>
                    )}
                    <UsersEmailTest style={{ maxWidth: '60%', margin: 0, marginTop: '20px', width: '100%' }}>
                        <div>
                            <p>Email Test</p>
                            <input
                                type="text"
                                value={inputValue}
                                onChange={(e) => setInputValue(e.target.value)}
                                placeholder="Email tester list"
                                style={{
                                    padding: '10px',
                                    marginRight: '10px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                }}
                            />
                            <button
                                onClick={() => addString()}
                                style={{
                                    padding: '10px 10px',
                                    backgroundColor: '#4CAF50',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    width: '150px',
                                }}
                            >
                                Add test users
                            </button>
                            <button style={{ backgroundColor: "#aaaaaa", padding: '10px 10px', }} onClick={() => handleTestEmail()}>
                                Send Test Email
                            </button>
                        </div>
                        <ul style={{ marginTop: '20px', listStyleType: 'none', padding: 0 }}>

                            {strings.map((str, index) => (
                                <li
                                    key={index}
                                    style={{

                                    }}
                                >
                                    {str}
                                    <button className='btn-remove-user' onClick={() => removeString(index)}>
                                        <BiTrash color='tomato' />
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </UsersEmailTest>
                </div>
                {/* <button className="button" onClick={() => setConfirmation(true)}>Publish</button> */}
                <button className="button" onClick={() => publishAnnouncement()}>Publish</button>
                {
                    myModal
                }
                {
                    preview
                }
                {
                    editorType === 'default' ? (
                        <div>

                            <button onClick={() => setMyPreview(myPreview ? false : true)}>Preview Content</button>
                        </div>
                    ) : (
                        <></>
                    )
                }
            </div>
    );
}

export default NewAnnouncement;